import { Injectable } from '@angular/core';

import { State } from '@ngxs/store';

@State({
  name: 'onboarding'
})
@Injectable()
export class OnboardingState {}
